import FontEditor from "./FontEditor.js";
import FontModel from "./FontModel.js";
export default {
  install(plg) {
    // Should this be separate and deliberate?
    plg.addPlugin('Model', {
      type: FontModel.TYPE,
      model: FontModel
    });
    plg.addPlugin('ModelEditor', {
      type: FontModel.TYPE,
      editor: FontEditor
    });
  }
};